import { LayoutMicroCopy } from "./Layout"
import { FooterCopy } from "../Footer/Footer"
import { FooterNavCopy } from "../Footer/FooterBase"

export const FALLBACK_MICROCOPY: LayoutMicroCopy = {
  messageSearchBar: {
    microcopyKey: "messageSearchBar",
    microcopyValue: {
      raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Search help articles","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
    }
  },
  headerSearchResults: {
    microcopyKey: "headerSearchResults",
    microcopyValue: {
      raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Results for","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
    }
  },
  buttonContactUs: {
    microcopyKey: "buttonContactUs",
    microcopyValue: {
      raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Contacto","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
    }
  },
  buttonBrowseHelpCenter: {
    microcopyKey: "buttonBrowseHelpCenter",
    microcopyValue: {
      raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Browse Help Center","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
    }
  },
  messageContactUs: {
    microcopyKey: "messageContactUs",
    microcopyValue: {
      raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Still have questions? Contact support.","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
    }
  },
  upperNavMicroCopySet: {
    microcopySetEntries: [
      {
        microcopyKey: "navigationHomepage",
        microcopyValue: {
          raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Help Center","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
        }
      },
      {
        microcopyKey: "navigationLogIn",
        microcopyValue: {
          raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Iniciar sesión","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
        }
      },
      {
        microcopyKey: "navigationBrowseEvents",
        microcopyValue: {
          raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Descubrir eventos","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
        }
      },
      {
        microcopyKey: "navigationTickets",
        microcopyValue: {
          raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Entradas","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
        }
      },
      {
        microcopyKey: "navigationManageMyEvents",
        microcopyValue: {
          raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Gestionar mis eventos","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
        }
      },
      {
        microcopyKey: "navigationAccountSettings",
        microcopyValue: {
          raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Ajustes de la cuenta","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
        }
      },
      {
        microcopyKey: "navigationLogOut",
        microcopyValue: {
          raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Cerrar sesión","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
        }
      }
    ]
  }
}

export const FALLBACK_FOOTERCOPY: FooterCopy = [
  {
    displayText: "Use Eventbrite",
    FooterNavigationChildItems: [
      {
        displayText: "Create events",
        footerNavigationUrl: "https://www.eventbrite.com/organizer/overview/"
      },
      {
        displayText: "Pricing",
        footerNavigationUrl: "https://www.eventbrite.com/organizer/pricing/"
      },
      {
        displayText: "Content standards",
        footerNavigationUrl: "https://www.eventbrite.com/l/contentstandards/"
      },
      {
        displayText: "Site status",
        footerNavigationUrl: "http://www.eventbritestatus.com/"
      }
    ]
  },
  {
    displayText: "Download apps",
    FooterNavigationChildItems: [
      {
        displayText: "Eventbrite app for iOS",
        footerNavigationUrl:
          "https://itunes.apple.com/us/app/eventbrite/id487922291"
      },
      {
        displayText: "Eventbrite app for Android",
        footerNavigationUrl:
          "https://play.google.com/store/apps/details?id=com.eventbrite.attendee&hl=en"
      },
      {
        displayText: "Eventbrite Organizer app",
        footerNavigationUrl:
          "https://www.eventbrite.com/l/organizer-check-in-app/"
      }
    ]
  },
  {
    displayText: "Browse resources",
    FooterNavigationChildItems: [
      {
        displayText: "Taxes",
        footerNavigationUrl: "https://www.eventbrite.com/l/taxes/"
      },
      {
        displayText: "Marketing tutorials",
        footerNavigationUrl: "https://docs-eb.toneden.io/"
      },
      {
        displayText: "Webinars for new organizers",
        footerNavigationUrl:
          "https://www.eventbrite.com/o/eventbrite-academy-30396073460"
      },
      {
        displayText: "Reconvene virtual sessions for organizers",
        footerNavigationUrl: "https://www.eventbrite.com/reconvene/"
      }
    ]
  },
  {
    displayText: "Connect with us",
    FooterNavigationChildItems: [
      {
        displayText: "Twitter",
        footerNavigationUrl: "https://twitter.com/eventbrite"
      },
      {
        displayText: "Facebook",
        footerNavigationUrl: "https://www.facebook.com/Eventbrite"
      },
      {
        displayText: "Instagram",
        footerNavigationUrl: "https://www.instagram.com/eventbrite/"
      },
      {
        displayText: "Contact support",
        footerNavigationUrl: "https://www.eventbrite.com/help/contact-us"
      }
    ]
  }
]

export const FALLBACK_FOOTERNAVCOPY: FooterNavCopy = [
  {
    displayText: "About",
    footerNavigationUrl: "https://www.eventbrite.com/about/"
  },
  {
    displayText: "Blog",
    footerNavigationUrl: "https://www.eventbrite.com/blog/"
  },
  {
    displayText: "Help",
    footerNavigationUrl: "https://www.eventbrite.com/help"
  },
  {
    displayText: "Careers",
    footerNavigationUrl: "https://www.eventbritecareers.com/home"
  },
  {
    displayText: "Press",
    footerNavigationUrl: "https://www.eventbrite.com/press"
  },
  {
    displayText: "Security",
    footerNavigationUrl: "https://www.eventbrite.com/security/"
  },
  {
    displayText: "Developers",
    footerNavigationUrl: "https://www.eventbrite.com/platform/"
  },
  {
    displayText: "Terms",
    footerNavigationUrl: "https://www.eventbrite.com/l/legalterms/"
  },
  {
    displayText: "Privacy",
    footerNavigationUrl: "https://www.eventbrite.com/privacypolicy/"
  },
  {
    displayText: "Accessibility",
    footerNavigationUrl: "https://www.eventbrite.com/l/accessibility/"
  },
  {
    displayText: "Cookies",
    footerNavigationUrl: "https://eventbrite.com/cookies"
  }
]
